<div class="modal__bkn">
    <button class="modal__close _icon-close" (click)="closeModal()"></button>
    <ng-container *ngIf="cnt$ | async as model;else sk">
        <div class="modal__bkn-bg"></div>
        <div class="modal__bkn-top">
            <picture [xSrc]="model.resolve.bk!.logo2"></picture>
            <span dir="auto" i18n="Модалка, кэфы, шапка@@MODAL_ODDS_HEAD">Is restricted in your country.</span>
        </div>

        <div class="modal__bkn-cnt">
            <svg width="400" height="120" viewBox="0 0 400 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M399.5 60C399.5 68.0419 394.065 75.8034 383.994 82.9469C373.935 90.0811 359.348 96.5264 341.278 101.947C305.143 112.788 255.194 119.5 200 119.5C144.806 119.5 94.8568 112.788 58.7223 101.947C40.6519 96.5264 26.0647 90.0811 16.0063 82.9469C5.93484 75.8034 0.5 68.0419 0.5 60C0.5 51.9581 5.93484 44.1966 16.0063 37.0531C26.0647 29.9189 40.6519 23.4736 58.7223 18.0525C94.8568 7.21215 144.806 0.5 200 0.5C255.194 0.5 305.143 7.21215 341.278 18.0525C359.348 23.4736 373.935 29.9189 383.994 37.0531C394.065 44.1966 399.5 51.9581 399.5 60Z" />
            </svg>
            <div class="modal__bkn-cnt-i">
                <i class="icon-fire"></i>
                <span dir="auto" i18n="Модалка, кэфы,заголовок@@MODAL_ODDS_TITLE">You can choose another bookmaker from
                    the list.</span>
                <div class="modal__bkn-crds">
                    <ng-container *ngFor="let bk of model.items">
                        <ng-container *ngTemplateOutlet="bonus; context:{bonus:bk.promo[0]}"> </ng-container>

                        <ng-template #bonus let-promo="bonus">
                            <a class="modal__bkn-crd" target="_blank" [href]="promo.url | gotoUrl">
                                <picture [xSrc]="bk.logo2"></picture>
                                <picture [xSrc]="bk.logo"></picture>
                                <div dir="auto">
                                    <span>{{promo.type}}</span>
                                    <span>{{promo.text}}</span>
                                    <i class="_icon-gift"></i>
                                </div>
                            </a>

                        </ng-template>
                    </ng-container>


                </div>
            </div>
        </div>




    </ng-container>

    <!--===================== СКЕЛЕТКА МОДАЛКА==================-->

    <ng-template #sk>
        <div class="modal__bkn-top sk&#45;&#45;mbkn">
            <picture class="sk__line"></picture>
            <span class="sk__line"></span>
        </div>
        <div class="modal__bkn-cnt sk&#45;&#45;mbkn">
            <svg width="400" height="120" viewBox="0 0 400 120" fill="none"
                xmlns="http://www.w3.org/2000/svg">&ndash;&gt;
                <path
                    d="M399.5 60C399.5 68.0419 394.065 75.8034 383.994 82.9469C373.935 90.0811 359.348 96.5264 341.278 101.947C305.143 112.788 255.194 119.5 200 119.5C144.806 119.5 94.8568 112.788 58.7223 101.947C40.6519 96.5264 26.0647 90.0811 16.0063 82.9469C5.93484 75.8034 0.5 68.0419 0.5 60C0.5 51.9581 5.93484 44.1966 16.0063 37.0531C26.0647 29.9189 40.6519 23.4736 58.7223 18.0525C94.8568 7.21215 144.806 0.5 200 0.5C255.194 0.5 305.143 7.21215 341.278 18.0525C359.348 23.4736 373.935 29.9189 383.994 37.0531C394.065 44.1966 399.5 51.9581 399.5 60Z" />
            </svg>
            <div class="modal__bkn-cnt-i ">
                <i class="icon-fire"></i>
                <span class="sk__line"></span>
                <div class="modal__bkn-crds">
                    <ng-container *ngFor="let sk of [1,1,1,1,1]">
                        <div class="modal__bkn-crd">
                            <picture></picture>
                            <div></div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-template>

</div>
